class SliderController {
    constructor(parentElement) {
        this.slides = this.generateSlides(parentElement);
        if (this.slides.length > 1) {
            this.bullets = parentElement.querySelector(".kac-slider-bullets").childNodes;
            this.currentSlide = 0;
            this.timer = null;
            this.isAnimating = false;

            this.setBullets(this.currentSlide);

            let self = this;

            parentElement.querySelector(".kac-slider-arrowleft").addEventListener("click", function(){
                self.forceMoveToSlide(self.stepIndex(false), false);
            });
            parentElement.querySelector(".kac-slider-arrowright").addEventListener("click", function(){
                self.forceMoveToSlide(self.stepIndex(true), true);
            });

            let bullets = parentElement.querySelectorAll(".kac-slider-bullets > *");
            for (let i = 0; i < bullets.length; i++) {
                bullets[i].addEventListener("click", function() {
                    self.forceMoveToSlide(i, self.determineDirection(i));
                });
            }

            this.startSlider();
        }

        this.initialAnimation();
    }

    generateSlides(parentElement) {
        let array = [];
        const mainElements = parentElement.querySelectorAll(".kac-slider-slide");
        const bgs = parentElement.querySelectorAll(".kac-slide-bg");

        // Every slide has a slide-bg and its content (in slider-slide), so the numbers are equal.

        for (let i = 0; i < mainElements.length; i++) {
            let contentContainer = mainElements[i].querySelector(".kac-slide-content");
            let content = Array.from(contentContainer.querySelectorAll(".kac-slide-content-inner > *"));

            array.push({
                contents: [contentContainer].concat(content),
                mainElement: mainElements[i],
                bg: bgs[i]
            });
        }

        return array;
    }

    // ASSERTION: The first (or whatever current) slide is animated in using a different animation,
    // e.g. by scrolling in the chapter or by letting the content fade in.
    // Also, the bullets are set within the constructor. So this is just starting the timer.
    startSlider() {
        let self = this;
        this.timer = setInterval(function() {
            self.moveToNextSlide(self.stepIndex(true), true);
        }, 8000);
    }

    stopSlider() {
        clearInterval(this.timer);
    }

    forceMoveToSlide(newIndex, forward) {
        if (this.moveToNextSlide(newIndex, forward)) {
            this.stopSlider();
            this.startSlider();
        }
    }

    moveToNextSlide(newIndex, forward) {
        if (!this.isAnimating) {
            this.slideOut(this.currentSlide, forward);
            this.slideIn(newIndex, forward);

            let largestInDuration = 1000, largestOutDuration = 600; // TODO: get actual animation duration

            this.setBullets(newIndex);
            this.currentSlide = newIndex;

            // set animation state depending on how long the animations took.
            this.isAnimating = true;
            let self = this;
            setTimeout(function() {
                self.isAnimating = false;
            }, (largestInDuration > largestOutDuration ? largestInDuration : largestOutDuration));

            return true;
        }

        return false;
    }

    setBullets(index) {
        for (let i = 0; i < this.bullets.length; i++) {
            this.bullets[i].classList.remove("kac-bulletchecked");
        }
        this.bullets[index].classList.add("kac-bulletchecked");
    }

    findMaxDuration(queue, forward) {
        const sumDuration = ( (animation, queue) => {
            if ("abortable" in animation && animation.abortable == true) {
                return 0;
            }

            let result = animation.duration;
            if ("delay" in animation) {
                result += animation.delay;
            }
            if ("staggered" in animation) {
                result += animation.staggered * (queue.length - 1);
            }

            return result;
        } );

        let largestDuration = 0;

        for (let action in queue) {
            let actionDuration = sumDuration((
                "reverse" in this.animations[action] && forward === false ?
                this.animations[action].reverse :
                this.animations[action].forward
            ), queue[action]);

            if (largestDuration < actionDuration) {
                largestDuration = actionDuration;
            }
        }

        return largestDuration;
    }

    stepIndex(forward = true) {
        if (forward == true) {
            return (this.currentSlide + 1) % this.slides.length;
        }
        let newIndex = this.currentSlide - 1;
        return (newIndex < 0 ? this.slides.length - 1 : newIndex);
    }

    determineDirection(index) {
        if (index > this.currentSlide) {
            if (index == this.slides.length - 1 && this.currentSlide == 0) {
                return false;
            } else {
                return true;
            }
        } else {
            if (index == 0 && this.currentSlide == this.slides.length - 1) {
                return true;
            } else {
                return false;
            }
        }
    }

    cssAnimate(elements, options) {
        let { name, duration, curve = "cubic-bezier(.6,0,.5,1)", delay = 0, staggered = 0 } = options;
        const animateElement = ( (element, name, duration, curve, delay) => {
            element.style.animation = name + " " +
                                      duration + "ms " +
                                      curve + " " +
                                      delay + "ms";
            element.style.animationFillMode = "forwards";
            element.style.animationDirection = "normal";
            element.style.animationPlayState = "running";
        } );

        if (elements instanceof Array) {
            for (let element of elements) {
                animateElement(element, name, duration, curve, delay);
                delay += staggered;
            }
        } else {
            animateElement(elements, name, duration, curve, delay);
        }
    }

    slideIn(index, forward) {
        const currentSlide = this.slides[index];
        const fadeElements = false;

        this.cssAnimate(currentSlide.contents, {
            name: "kac-content-fadein",
            duration: 160,
            curve: (fadeElements == true ? "ease-in" : "steps(1, end)"),
            staggered: 50
        });

        this.cssAnimate([currentSlide.mainElement, currentSlide.bg], (
            forward == true ? {
                name: "kac-slider-slidein",
                duration: 600
            } : {
                name: "kac-slider-slidein-reverse",
                duration: 600
            }
        ));
    }

    initialAnimation() {
        const currentSlide = this.slides[0];
        const fadeElements = false;

        this.cssAnimate(currentSlide.contents, {
            name: "kac-content-fadein",
            duration: 160,
            curve: (fadeElements == true ? "ease-in" : "steps(1, end)"),
            staggered: 50
        });

        this.cssAnimate(currentSlide.mainElement, {
            name: "kac-slider-slidein",
            duration: 600
        });
    }

    slideOut(index, forward) {
        const currentSlide = this.slides[index];
        const fadeElements = false;

        this.cssAnimate(currentSlide.contents, {
            name: "kac-fadeout",
            duration: 100,
            curve: (fadeElements == true ? "ease-in" : "steps(1, end)"),
            // staggered: 65
        });

        this.cssAnimate(currentSlide.bg, {
            name: "kac-fadeout",
            duration: 600,
            curve: "steps(1, end)",
        });
        this.cssAnimate(currentSlide.mainElement, (
            forward == true ? {
                name: "kac-slider-slideout",
                duration: 600
            } : {
                name: "kac-slider-slideout-reverse",
                duration: 600
            }
        ));
    }
}

document.addEventListener('DOMContentLoaded', function() {
    let foundSlider = document.querySelector(".kac-slider");
    if (foundSlider != null) {
        new SliderController(foundSlider);
    }
}, false);
